import type { Price, Service } from '../../../../packages/contracts/src/index.js';

export function isOperationalRateService(service: Pick<Service, 'category'>) {
  return service.category === 'daycare' || service.category === 'boarding';
}

export function isOperationalRatePrice(service: Pick<Service, 'category'>, price?: Pick<Price, 'billingUnit'>) {
  return (service.category === 'daycare' && (price?.billingUnit === 'hour' || price?.billingUnit === 'entrance')) || (service.category === 'boarding' && price?.billingUnit === 'night');
}
